import React from 'react'
// import { AddTaskForm } from 'src/components/sample-tasks/add-task';
// import { TaskList } from 'src/components/sample-tasks/get-tasks';

import PageHeader from 'src/components/shared/page-header';
import Teams from 'src/components/teams';

const HomePage: React.FC = () => {

  return (
    <div className="min-h-screen w-full flex flex-col">
      <PageHeader title='Teams'
       description='Manage your teams and workers here.'
       />
        <div className="flex items-center flex-col gap-2">   
         <Teams/>
        </div>
        {/* <div className='flex w-full items-start justify-between'>
         <div className='flex flex-col w-full'>
           <div>
            <AddTaskForm defaultCount={2}/>
          </div>
          <TaskList />
         </div>
        </div> */}
    </div>
  )
}

export default HomePage

